import { createDatePreset } from "../types/interactions";
import { SavedSettingsStorage } from "../services/savedSettingsStorage";
export const saveCurrentSettings = (name, options) => {
    var _a, _b;
    try {
        const { dateRange, selectedAccounts, selectedUsers, viewSettings, contextSelection } = options;
        const existingPreset = SavedSettingsStorage.findByName(name);
        const baseSettings = {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate,
            datePreset: dateRange.preset,
            isRelativeDate: dateRange.preset !== "custom" && dateRange.preset !== undefined,
            selectedAccounts: selectedAccounts.map((acc) => acc.id),
            selectedUsers: selectedUsers.map((user) => user.id),
            viewSettings: {
                excludeHangupsAndDisconnects: viewSettings.excludeHangupsAndDisconnects,
                minimumCallDurationSeconds: viewSettings.minimumCallDurationSeconds,
                chartDataRange: viewSettings.chartDataRange,
                defaultStartTime: (_a = dateRange.startTime) !== null && _a !== void 0 ? _a : null,
                defaultEndTime: (_b = dateRange.endTime) !== null && _b !== void 0 ? _b : null,
            },
        };
        const settingsToSave = {
            id: existingPreset ? existingPreset.id : SavedSettingsStorage.generateId(),
            name: name.trim(),
            dateCreated: existingPreset ? existingPreset.dateCreated : new Date().toISOString(),
            dateModified: new Date().toISOString(),
            settings: viewSettings.selectedKPI
                ? {
                    ...baseSettings,
                    accountObjects: contextSelection.accounts,
                    userObjects: contextSelection.users,
                    kpiSettings: {
                        enabled: true,
                        excellent: viewSettings.selectedKPI.thresholds.excellent,
                        good: viewSettings.selectedKPI.thresholds.good,
                        acceptable: viewSettings.selectedKPI.thresholds.acceptable,
                        requiresCallback: viewSettings.selectedKPI.filters.requiresCallback,
                        controlledTransfersOnly: viewSettings.selectedKPI.filters.controlledTransfersOnly || false,
                        blindTransfersOnly: viewSettings.selectedKPI.filters.blindTransfersOnly || false,
                        handoffTransfersOnly: viewSettings.selectedKPI.filters.handoffTransfersOnly || false,
                        originators: viewSettings.selectedKPI.filters.originators || [],
                        priorities: viewSettings.selectedKPI.filters.priorities || [],
                        reasons: viewSettings.selectedKPI.filters.reasons || [],
                    },
                }
                : {
                    ...baseSettings,
                    accountObjects: contextSelection.accounts,
                    userObjects: contextSelection.users,
                },
        };
        SavedSettingsStorage.save(settingsToSave);
    }
    catch (error) {
        console.error("Failed to save settings:", error);
        throw new Error("Failed to save preset. Please try again.");
    }
};
export const loadSettings = (settings, options) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    try {
        const { isStandaloneMode, setInternalDateRange, setContextSelection, updatePartialViewSettings, hidePresetsWithTransition, } = options;
        if (isStandaloneMode) {
            let dateRangeToLoad;
            if (settings.settings.isRelativeDate &&
                settings.settings.datePreset &&
                settings.settings.datePreset !== "custom") {
                dateRangeToLoad = {
                    ...createDatePreset(settings.settings.datePreset),
                    startTime: (_b = (_a = settings.settings.viewSettings) === null || _a === void 0 ? void 0 : _a.defaultStartTime) !== null && _b !== void 0 ? _b : null,
                    endTime: (_d = (_c = settings.settings.viewSettings) === null || _c === void 0 ? void 0 : _c.defaultEndTime) !== null && _d !== void 0 ? _d : null,
                };
            }
            else {
                dateRangeToLoad = {
                    startDate: settings.settings.startDate,
                    endDate: settings.settings.endDate,
                    preset: "custom",
                    startTime: (_f = (_e = settings.settings.viewSettings) === null || _e === void 0 ? void 0 : _e.defaultStartTime) !== null && _f !== void 0 ? _f : null,
                    endTime: (_h = (_g = settings.settings.viewSettings) === null || _g === void 0 ? void 0 : _g.defaultEndTime) !== null && _h !== void 0 ? _h : null,
                };
            }
            setInternalDateRange(dateRangeToLoad);
        }
        if (isStandaloneMode) {
            const contextAccounts = settings.settings.accountObjects || [];
            const contextUsers = settings.settings.userObjects || [];
            setContextSelection({
                accountIds: settings.settings.selectedAccounts || [],
                userIds: settings.settings.selectedUsers || [],
                privilegeGroupIds: [],
                accounts: contextAccounts,
                users: contextUsers,
                privilegeGroups: [],
            });
        }
        if ((_j = settings.settings.kpiSettings) === null || _j === void 0 ? void 0 : _j.enabled) {
            const kpiConfig = {
                id: `loaded-${Date.now()}`,
                name: `${settings.name} KPI`,
                filters: {
                    requiresCallback: settings.settings.kpiSettings.requiresCallback,
                    controlledTransfersOnly: settings.settings.kpiSettings.controlledTransfersOnly || false,
                    blindTransfersOnly: settings.settings.kpiSettings.blindTransfersOnly || false,
                    handoffTransfersOnly: settings.settings.kpiSettings.handoffTransfersOnly || false,
                    originators: settings.settings.kpiSettings.originators || [],
                    priorities: settings.settings.kpiSettings.priorities || [],
                    reasons: settings.settings.kpiSettings.reasons || [],
                },
                thresholds: {
                    excellent: settings.settings.kpiSettings.excellent,
                    good: settings.settings.kpiSettings.good,
                    acceptable: settings.settings.kpiSettings.acceptable,
                },
                createdAt: new Date().toISOString(),
            };
            updatePartialViewSettings({ selectedKPI: kpiConfig });
        }
        else {
            updatePartialViewSettings({ selectedKPI: undefined });
        }
        if (settings.settings.viewSettings) {
            const viewSettingsUpdate = {};
            if (settings.settings.viewSettings.excludeHangupsAndDisconnects !== undefined) {
                viewSettingsUpdate.excludeHangupsAndDisconnects = settings.settings.viewSettings.excludeHangupsAndDisconnects;
            }
            if (settings.settings.viewSettings.minimumCallDurationSeconds !== undefined) {
                viewSettingsUpdate.minimumCallDurationSeconds = settings.settings.viewSettings.minimumCallDurationSeconds;
            }
            if (settings.settings.viewSettings.chartDataRange !== undefined) {
                viewSettingsUpdate.chartDataRange = settings.settings.viewSettings.chartDataRange;
            }
            if (Object.keys(viewSettingsUpdate).length > 0) {
                updatePartialViewSettings(viewSettingsUpdate);
            }
        }
        hidePresetsWithTransition();
    }
    catch (error) {
        console.error("Failed to load settings:", error);
        throw new Error("Failed to load preset. Please try again.");
    }
};
//# sourceMappingURL=settingsManagementUtils.js.map